export const MESSAGE_EAN =
  "Code à 13 chiffres, qui vous a été fourni par votre agence ISBN et sert à générer un code à barres lisible par machine";
export const MESSAGE_MOTDEPASSE = `Votre mot de passe doit être constitué de :
- Au minimum 8 caractères
- Un caractère spécial ($, !, *, ...)
- Une majuscule
- Un nombre`;